import React from 'react';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Avatar from '@mui/material/Avatar';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Card, Grid, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
// project imports
import { gridSpacing } from '../../store/constant';

// assets
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import NotInterestedTwoToneIcon from '@mui/icons-material/NotInterestedTwoTone';
import ChatBubbleTwoToneIcon from '@mui/icons-material/ChatBubbleTwoTone';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';


// ==============================|| USER DETAILS CARD ||============================== //

const UserDetailsCard = ({ name, photo, createdDate, gender, lastName, analysisType, jawType, sendStatus, caseId, planName, planTag, upperCount, lowerCount, casePk, analysisPk, status, processCount, processingData,isCancelled,doctor,case_type }) => {
    const theme = useTheme();
    const isOutsourceRole = JSON.parse(localStorage.getItem('userData'))?.role === 'ortheroanatecoutsource' || JSON.parse(localStorage.getItem('userData'))?.role === 'ortheroanateconyx';

    const formatName = (str) => {
        if (!str) return "";
        try {
            return str.split(" ").filter(w => w.length > 0).map(word => word.charAt(0) + "*".repeat(word.length - 1)).join(" ");
        } catch {
            return str.split("").map(c => c === " " ? " " : "*").join("");
        }
    };

    const colors = () => theme.palette.mode === "dark" ? { color: theme.palette.grey[700], fontSize: "13px", textTransform: 'uppercase', fontWeight: 'bold' } : { color: "#673AB7", fontSize: "13px", textTransform: 'uppercase', fontWeight: 'bold' }

    const styles = {
        txtOne: { border: "1px solid #673AB7", padding: "7px", borderRadius: "50px", fontSize: "12px", color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : "#673AB7" },
        planTag: { width: "60px", height: "60px", background: theme.palette.mode === 'dark' ? "#f2f4f6" : "#EDE7F6", display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: "50%", fontSize: "1.8rem", color: '#673AB7' },
        upperLower: { width: "23px", height: "23px", background: theme.palette.mode === 'dark' ? theme.palette.dark.main : "#EDE7F6", fontWeight: 'bold', borderRadius: "50%", paddingTop: "6%" },
        jawType: { border: "1px solid #673AB7", borderRadius: "30px", padding: "8px" }
    }

    const translateHandler = (analysisType) => {
        if (analysisType.length > 1) {
            return <FormattedMessage id={analysisType} />

        }
        else {
            return analysisType
        }

    }

    const fallbackCopy = (text) => {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand("copy");
            console.log("Fallback ile kopyalandı");
        } catch (err) {
            console.error("Fallback kopyalama başarısız", err);
        }
        document.body.removeChild(textarea);
    }


    return (
        <Card
            sx={{
                margin: '0px',
                background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
                padding: '10px',
                '&:hover': {
                    borderColor: theme.palette.primary.main
                }
            }}
        >
            <Grid mt={1} sx={{ background: theme.palette.mode === 'dark' ? theme.palette.dark.main : "#EDE7F6", padding: "12px", color: "#673AB7", borderRadius: "4px" }} display="flex" flexWrap="wrap" justifyContent={"space-between"}>
                <Grid>
                    <Typography mt={0.3} style={colors()}>
                        {translateHandler(analysisType)}
                    </Typography>
                </Grid>
                {!window.location.href.includes('gallery') &&
                    <Grid style={colors()}>
                        <span style={styles.jawType}>  <FormattedMessage id={jawType} /> </span>
                    </Grid>}
                <Grid style={colors()} onClick={() => fallbackCopy(caseId)}>
                    {caseId}    
                </Grid>
            </Grid>
            <Grid ml={1.5} mt={2}>
                        <Typography fontSize="16px" color={theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#333'}>
                            <b><FormattedMessage id="Doctor" defaultMessage="Doctor" />:</b> {isOutsourceRole
                              ? formatName(doctor)
                              : doctor
                            }
                        </Typography>
                    </Grid>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                    <Grid container spacing={gridSpacing}>
                    </Grid>
                </Grid>
                <Grid display="flex" justifyContent="center" alignItems="center" item xs={11}>
                    <Grid>
                        <Stack direction="row" spacing={2}>
                            <Avatar
                                alt="Remy Sharp"
                                src={photo}
                                sx={{ width: 65, height: 65 }}
                            />
                        </Stack>
                    </Grid>
                    <Grid style={{ textAlign: "start" }} ml={2}>
                        <Typography variant="h5" sx={theme.palette.mode === 'dark' ? { color: theme.palette.grey[700] } : { color: "#673AB7" }}>
                            {isOutsourceRole
                                ? `${formatName(name)} ${formatName(lastName)}`
                                : `${name} ${lastName}`
                            }
                        </Typography>
                        <Grid display="flex" justifyContent="space-between">
                            <Typography mt={1} variant="subtitle2" sx={{ color: theme.palette.grey[700] }}>
                                <FormattedMessage id="Created" /> <br /> <span style={theme.palette.mode === 'dark' ? { fontSize: "13.5px", color: theme.palette.grey[700] } : { fontSize: "13.5px", color: "#000" }}>{createdDate}</span>
                            </Typography>
                            <Typography mt={1} ml={3} variant="subtitle2" sx={{ color: theme.palette.grey[700] }}>
                                <FormattedMessage id="Gender" /><br /> <span style={theme.palette.mode === 'dark' ? { fontSize: "13.5px", textAlign: 'center', color: theme.palette.grey[700] } : { fontSize: "13.5px", color: "#000", textAlign: 'center' }}><FormattedMessage id={gender} /></span>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid width="85%" marginLeft="30px">
                    <Grid mt={2} width="100%" bgcolor="#f2f4f6" height="1px"></Grid>
                    
                    <Grid ml={1.5} display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                        <Typography fontWeight="bold" ><FormattedMessage id="Last Plan" /></Typography>
                        <Typography style={styles.txtOne}><FormattedMessage id={status} /></Typography>
                    </Grid>
                    <Grid mt={2} display="flex" justifyContent="center">
                        <Grid style={styles.planTag} >{planTag}</Grid>
                        <Grid mt={0.8} display="flex" flexDirection="column" xs={8}>
                            <Typography fontWeight="bold" >{planName} </Typography>
                            <Grid mt={1} display="flex" justifyContent="space-evenly">
                                <Grid display="flex">
                                    <Grid style={styles.upperLower}>U</Grid>
                                    <Grid ml={1} mt={0.2}>{upperCount}</Grid>
                                </Grid>
                                <Grid display="flex">
                                    <Grid style={styles.upperLower}>L</Grid>
                                    <Grid ml={1} mt={0.2}>{lowerCount}</Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {/* <Grid item xs={12}>
                    <Typography variant="subtitle2" sx={{ color: theme.palette.grey[700] }}>
                        {about}
                    </Typography>
                </Grid> */}
                {/* <Grid item xs={12}>
                    <Typography variant="caption">Email</Typography>
                    <Typography variant="h6">{email}</Typography>
                </Grid> */}
                {/* <Grid item xs={12}>
                    <Grid container spacing={gridSpacing}>
                        <Grid item xs={6}>
                            <Typography variant="caption">Phone</Typography>
                            <Typography variant="h6">{contact}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="caption">Location</Typography>
                            <Typography variant="h6">{location}</Typography>
                        </Grid>
                    </Grid>
                </Grid> */}
                {!window.location.href.includes('gallery') &&
                    <Grid ml={1} mr={1} mb={1} item xs={12}>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                {processCount === 0 ?
                                    <Link style={{ textDecoration: 'none' }} to={{ pathname: `/anateccasedetail/${casePk}` }} state={{ pk: casePk }} > <Button style={{ fontSize: "12px" }} variant="contained" fullWidth >
                                        <FormattedMessage id="View Records" />
                                    </Button> </Link>
                                    :
                                    <Link style={{ textDecoration: 'none' }} to={{ pathname: isCancelled ? `/anateccasedetail/${casePk}` : `/anateccasedetail//${casePk}` }} state={{ pk: casePk }} > <Button style={{ background: "#fafafa", color: 'red', border: '1px solid red', fontSize: "12px" }} variant="contained" fullWidth >

                                        <FormattedMessage id="Missing Records!" />
                                    </Button> </Link>
                                }
                            </Grid>
                            {analysisPk !== "" ?
                                <Grid onContextMenu={(e) => e.preventDefault()} item xs={6}>
                                    {processCount === 0 ?
                                        <>
                                            {planName.includes('Herotain') ?
                                                <Grid onContextMenu={(e) => e.preventDefault()} item xs={12}>
                                                    <Button style={{ fontSize: "12px" }} variant="contained" disabled fullWidth >
                                                        <FormattedMessage id="View 3D Plan" />
                                                    </Button>
                                                </Grid>
                                                :
                                               <a href={`/new/anatecviewer/${casePk}/${analysisPk}`} style={{ textDecoration: 'none' }}>
                                                    <Button style={{ fontSize: "12px" }} variant="contained" fullWidth>
                                                        <FormattedMessage id="View 3D Plan" />
                                                    </Button>
                                                </a>
                                            }
                                        </>
                                        :
                                        <Link style={{ textDecoration: 'none' }} to={{ pathname: isCancelled ? `/anateccasedetail/${casePk}` : `/anateccasedetail//${casePk}` }} state={{ pk: casePk }} > <Button color="error" style={{ fontSize: "14px", fontWeight: "500" }} variant="outlined" fullWidth >
                                            <FormattedMessage id="Complate Form" />
                                        </Button> </Link>}
                                </Grid>
                                :
                                <Grid onContextMenu={(e) => e.preventDefault()} item xs={6}>
                                    <Button style={{ fontSize: "12px" }} variant="contained" disabled fullWidth >
                                        <FormattedMessage id="View 3D Plan" />
                                    </Button>
                                </Grid>
                            }
                        </Grid>
                    </Grid>}
            </Grid>
        </Card>
    );
};
{/* 136228 */ }
UserDetailsCard.propTypes = {
    about: PropTypes.string,
    avatar: PropTypes.string,
    contact: PropTypes.string,
    email: PropTypes.string,
    location: PropTypes.string,
    name: PropTypes.string,
    role: PropTypes.string
};

export default UserDetailsCard;
